export default __webpack_public_path__ + "static/img-mask-network-9c624782b95c6619db6109f9e9e38dce.png";